export const DEFAULT_DEBOUNCE = 500

export const ISO8601 = 'YYYY-MM-DD'
export const ISO8601_SECONDS = 'YYYY-MM-DD HH:mm:ss'

export const ONE_HUNDRED_PERCENT = 100

export const TIPPY_DISTANCE_OFFSET = 4
